<script setup lang="ts">
    // @ts-nocheck
    import { toRefs } from "vue";
    import { Vardplatsbestallning } from "@/tabs/Vardplatsbokning/types";
    import KFormDisplay from "@/components/forms/displays/FormDisplay/KFormDisplay.vue";
    import KFormFieldDisplay from "@/components/forms/displays/FormFieldDisplay/KFormFieldDisplay.vue";

    const props = defineProps<{
        vardplatsbestallning: Vardplatsbestallning;
    }>();

    const { vardplatsbestallning } = toRefs(props);
</script>

<template>
    <KFormDisplay class="dialog-vardplatsbestallning-info" :showEmptyValues="true">
        <template #default>
            <div class="form-content">
                <KFormFieldDisplay
                    name="operationsdatum"
                    label="Operationsdatum"
                    margin="small"
                    :value="vardplatsbestallning.operationsdatum"
                />
                <KFormFieldDisplay
                    name="installelsetid"
                    label="Inställelsetid"
                    margin="small"
                    :value="vardplatsbestallning.installelsetid?.substring?.(0, 5)"
                />
                <KFormFieldDisplay
                    name="operator"
                    label="Operatör"
                    margin="small"
                    :value="`${vardplatsbestallning.operator.namn}, ${vardplatsbestallning.vardgivare.namn}`"
                />
                <KFormFieldDisplay
                    name="typoperation"
                    label="Typoperation / Operationskod"
                    margin="small"
                    :value="
                        vardplatsbestallning.typoperation
                            ? vardplatsbestallning.typoperation
                            : `${vardplatsbestallning.huvudoperationskod.code} ${vardplatsbestallning.huvudoperationskod.displayName}`
                    "
                />
            </div>
        </template>
    </KFormDisplay>
</template>

<style lang="scss">
    .dialog-vardplatsbestallning-info {
        margin: 34px 0;
    }
</style>
